// errors-handler.ts
import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import bugsnag from 'bugsnag-js';
import { SessionService } from '../services';
import { environment } from '../../environments/environment';
import { ToasterService } from 'angular2-toaster';

@Injectable()
export class ErrorHandlerHelper implements ErrorHandler {

  constructor(private sessionService: SessionService, private toasterService: ToasterService) {
  }

  handleError(error: Error | HttpErrorResponse) {
    if (error && error.message && (error.message).indexOf('limited.map is not a function') > -1) {
      return;
    }

    if (error && error.toString() && error.toString().indexOf('n.map') > -1) {
      return;
    }

    // Emit event only in production
    if (environment.production) {

      const bugSnagClient = bugsnag({ appVersion: environment.appVersion, apiKey: '4c04ddb8868eaad868b9d86299898e2d', releaseStage: environment.production ? 'production' : 'development' });
      const user = localStorage.getItem('userData');
      if (user) {
        bugSnagClient.user = JSON.parse(user);
      }

      const chunkFailedMessage = /Loading chunk [\d]+ failed/;

      if (error && error.message && chunkFailedMessage.test(error.message)) {
        window.location.reload();
      }

      // Handle Load chunk errors
      if (error['originalStack'] && error['originalStack'].indexOf('Error: Loading chunk') >= 0) {
        // Check if is the first time the error happened
        if (localStorage.getItem('lastChunkError') !== error['originalStack']) {
          // Save the last error to avoid an infinite reload loop if the chunk really does not exists after reload
          localStorage.setItem('lastChunkError', error['originalStack']);
          location.reload();
        } else {

          // The chunk really does not exists after reload
          console.error('We really can\'t find the chunk...');

        }
      } else if (error instanceof HttpErrorResponse) {
        // Server or connection error happened
        if (!navigator.onLine) {
          // Handle offline error
        } else {
          // Handle Http Error (error.status === 403, 404...)
          bugSnagClient.notify(error, {
            severity: 'warning'
          });
        }
      } else {

        // Client side error
        bugSnagClient.notify(error);

        console.error('An error has been catched and reported:', error.message);
        this.sessionService.set('_error', error.stack);
        // return location.href = location.origin;
      }
    } else {
      // Log the error in dev || local environment
      console.error('Error catched =>', error);
    }
  }

}
